/* eslint-disable no-param-reassign */
const module = {
  namespaced: true,
  state: {
    isLoaded: false,
    percentage: 0,
    stepsToLoad: 0,
    stepsLoaded: 0,
  },
  mutations: {
    updateIsLoaded(state, isLoaded) {
      state.isLoaded = isLoaded;
    },
    updatePercentage(state, percentage) {
      state.percentage = percentage;
    },
    updateStepsToLoad(state, steps) {
      state.stepsToLoad = steps;
    },
    updateStepsLoaded(state, steps) {
      state.stepsLoaded = steps;
    },
  },
};

export default module;
